/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Divider, Stack, useMantineTheme } from '@mantine/core';
import React from 'react';

import Profile from '@fai/friendli-suite/views/layout/header/profile-combobox/profile';

export function ProfileComboBox({
  handleOnClickUserSettings,
  handleSignOut,
  handleFeedback,
}: {
  handleOnClickUserSettings: VoidFunction;
  handleSignOut: () => Promise<void>;
  handleFeedback: VoidFunction;
}) {
  const theme = useMantineTheme();

  return (
    <Profile>
      <Profile.Target />
      <Profile.DropDown>
        <React.Suspense>
          <Profile.DropDown.UserEmail />
        </React.Suspense>
        <Divider color={theme.pf.color.border.neutral.default} />
        <Stack gap={0} p={theme.pf.layout['4xs']}>
          {/* FIXME: refactor to map from an array {icon:ReactElement, label:string, onClickHandler?: Voidfunction }[] */}
          <Profile.DropDown.UserSettings onClick={handleOnClickUserSettings} />
          <Profile.DropDown.Feedback onClick={handleFeedback} />
          <Profile.DropDown.SignOut onClick={handleSignOut} />
        </Stack>
      </Profile.DropDown>
    </Profile>
  );
}
